module.exports = __webpack_public_path__ + "img/page-box-5.6eb1334.jpg";